/**
 * @desc 查询某个场次的报名记录
 */
import {
  ApplyEntity,
  TradeSessionApplyMemberListParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTradeSessionApplyListParameter =
  TradeSessionApplyMemberListParam

const method = 'GET'
const url = '/trade/member/apply/tradeSession'

export const queryTradeSessionApplyListApi = (
  params?: QueryTradeSessionApplyListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<ApplyEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryTradeSessionApplyListApi.method = method
queryTradeSessionApplyListApi.url = url
